import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
const steps = ["Open the system.", "Explore all six volumes.", "Review the case framework.", "Work through the educational cases.", "Download the worksheets.", "Print the review tools.", "Explore the bonus materials."];
export function Guarantee() {
  return <section className="bg-white px-4 py-16" data-id="element-159" data-mp="2ed03tka43o5z">
      <div className="mx-auto max-w-2xl" data-id="element-160" data-mp="2ebyimmzdtlaj">
        <div className="rounded-3xl border-2 border-gold bg-cream p-6 text-center sm:p-10" data-id="element-161" data-mp="2efdvdj5l2i8s">
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-ink text-goldsoft" data-id="element-162" data-mp="2je7afg0iqhb2">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden data-id="element-163" data-mp="2scsph16s7e73" />
          </div>
          <p className="mt-4 text-[13px] font-bold uppercase tracking-wider text-gold" data-id="element-164" data-mp="2saoniosg0p9g">7-day guarantee</p>
          <h2 className="mt-1 font-serif text-[28px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-165" data-mp="tzizlj7kt7f5">
            Explore the Atlas™ without unnecessary risk
          </h2>
          <ul className="mx-auto mt-6 max-w-sm space-y-1.5 text-left text-[16px] text-ink" data-id="element-166" data-mp="3smzrnbzqnw2t">
            {steps.map(s => <li key={s} className="flex gap-2" data-id="element-167" data-mp="3nsviqn6wxdz3">
                <span className="text-gold" aria-hidden data-id="element-168" data-mp="3iwonppg21mvx">•</span>
                {s}
              </li>)}
          </ul>
          <p className="mt-6 text-[16px] leading-relaxed text-muted" data-id="element-169" data-mp="3dyddhdlulad6">
            If you decide within 7 days that the system isn’t useful for your professional education and case-review
            process, contact us according to the stated purchase terms and you’ll be eligible for a refund under the
            guarantee conditions.
          </p>
          <p className="mt-3 text-[18px] font-bold text-ink" data-id="element-170" data-mp="i5mzb6cuevg">No unnecessary risk.</p>
        </div>
        <CTAButton className="mt-10" label="Try the Atlas™ for 7 days" data-id="element-171" data-mp="2q7he9vf2bcvw" />
      </div>
    </section>;
}